module.exports = __webpack_public_path__ + "static/media/img32.4745ad44.jpg";